import Award from 'assets/images/profile/award.png';

export const AWARDS = [
    // Challenge Milestones
    {
        id: 'first_challenge',
        title: 'First Steps',
        description: 'Complete your first coding challenge',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/first_steps.png",
        condition: (_, stats) => (stats?.totalChallenges || 0) >= 1
    },
    {
        id: 'challenge_20',
        title: 'It\'s Getting Real',
        description: 'Complete 20 challenges',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/challenge_20.png",
        condition: (_, stats) => (stats?.totalChallenges || 0) >= 20
    },
    {
        id: 'challenge_100',
        title: 'The Big 100',
        description: 'Complete 100 challenges',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/challenge_100.png",
        condition: (_, stats) => (stats?.totalChallenges || 0) >= 100
    },
    {
        id: 'challenge_250',
        title: 'Code Warrior',
        description: 'Complete 250 challenges',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/challenge_250.png",
        condition: (_, stats) => (stats?.totalChallenges || 0) >= 250
    },
    {
        id: 'challenge_500',
        title: 'Legend',
        description: 'Complete 500 challenges',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/challenge_500.png",
        condition: (_, stats) => (stats?.totalChallenges || 0) >= 500
    },

    // Daily & Streaks
    {
        id: 'daily_grinder',
        title: 'Daily Grinder',
        description: 'Complete 50 challenges in a single day',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/daily_grinder.png",
        condition: (_, stats) => (stats?.bestDailyChallenges || 0) >= 50
    },
    {
        id: 'streak_3',
        title: 'On Fire!',
        description: 'Reach a 3-day streak',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/streak_3.png",
        condition: (_, stats) => (stats?.bestStreak || 0) >= 3
    },
    {
        id: 'streak_7',
        title: 'Unstoppable!',
        description: 'Reach a 7-day streak',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/streak_7.png",
        condition: (_, stats) => (stats?.bestStreak || 0) >= 7
    },

    // Concept Milestones
    {
        id: 'concepts_3',
        title: 'Explorer',
        description: 'Learn 3 unique concepts',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/concepts_3.png",
        condition: (_, stats) => (stats?.uniqueConcepts || 0) >= 3
    },
    {
        id: 'concepts_10',
        title: 'Concept Master',
        description: 'Master 10 unique concepts',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/concepts_10.png",
        condition: (_, stats) => (stats?.uniqueConcepts || 0) >= 10
    },

    // Special Awards
    {
        id: 'night_owl',
        title: 'Night Owl',
        description: 'Complete 10 challenges between 9 PM and 12 AM',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/night_owl.png",
        condition: (_, stats) => {
            if (!stats || !stats.challengeCompletionDates) return false;
            const nightOwlCompletions = stats.challengeCompletionDates.filter(dateStr => {
                const date = new Date(dateStr);
                const hour = date.getHours();
                return hour >= 21 && hour < 24;
            });
            return nightOwlCompletions.length >= 10;
        }
    },
    {
        id: 'early_bird',
        title: 'Early Bird',
        description: 'Complete 10 challenges between 2 AM and 7 AM',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/early_bird.png",
        condition: (_, stats) => {
            if (!stats || !stats.challengeCompletionDates) return false;
            const earlyBirdCompletions = stats.challengeCompletionDates.filter(dateStr => {
                const date = new Date(dateStr);
                const hour = date.getHours();
                return hour >= 2 && hour < 7;
            });
            return earlyBirdCompletions.length >= 10;
        }
    },
    {
        id: 'persistent_programmer',
        title: 'Persistent Programmer',
        description: 'Attempt a challenge 5 times before completing it',
        icon: "https://hsttyumxyzygrtnyhqoy.supabase.co/storage/v1/object/public/Badges/persistent_programmer.png",
        condition: (_, stats) => (stats?.challengesWithMultipleAttempts || 0) >= 5
    }


];
